import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { EncryptPreLogin, DecryptPreLogin } from '../../middleware/CryptoMiddleWare';
import { getSessionData, MLMPlanTypeKey, PinRegistrationEnableKey, removeSessionData, setSessionData } from '../../components/common/constant';
import { CheckUserDetailsPreLogin, GetAppCongfigKeyDetailsPreLogin, GetCityList, GetStateList, LoginAuth, VerifyPreUserOTP } from '../apiPath';
import { htmlDecode, generateUniqueId } from '../../components/common/commonFunction';
import { createEncryptedAsyncThunk } from '../../Utility/APIUtils';
import _ from 'lodash';

const CryptoJS = require('crypto-js');

const key = process.env.REACT_APP_TOEKEN_KEY;
const header = {
  Accept: "application/json",
  PT: process.env.REACT_APP_API_KEY,
  "Content-Type": "application/json",
};

// Check if tabId is already in sessionStorage, if not, generate and store it
let tabId = getSessionData("tabId");
if (!tabId) {
  tabId = generateUniqueId(36, 2, 15);
  setSessionData("tabId", tabId);
}
let tabId2 = getSessionData("tabId2");
if (!tabId2) {
  tabId2 = generateUniqueId(36, 2, 25);
  setSessionData("tabId2", tabId2);
}


const user = JSON.parse(sessionStorage.getItem(`user${tabId}`))
  ? JSON.parse(
      CryptoJS.AES.decrypt(JSON.parse(sessionStorage.getItem(`user${tabId}`)), key).toString(
        CryptoJS.enc.Utf8,
      ),
    )
  : null;
const token = JSON.parse(sessionStorage.getItem(`token${tabId2}`))
  ? JSON.parse(
      CryptoJS.AES.decrypt(JSON.parse(sessionStorage.getItem(`token${tabId2}`)), key).toString(
        CryptoJS.enc.Utf8,
      ),
    )
  : null;
const info = JSON.parse(sessionStorage.getItem(`info`))
  ? JSON.parse(
      CryptoJS.AES.decrypt(JSON.parse(sessionStorage.getItem(`info`)), key).toString(
        CryptoJS.enc.Utf8,
      ),
    )
  : null;
const cfsf = JSON.parse(sessionStorage.getItem(`CfSERTQAER`))
  ? JSON.parse(
      CryptoJS.AES.decrypt(JSON.parse(sessionStorage.getItem(`CfSERTQAER`)), key).toString(
        CryptoJS.enc.Utf8,
      ),
    )
  : null;

const initialState = user
  ? { isLoggedIn: true, user, token, info, cfsf, planType: '', pinRegistartion: false }
  : { isLoggedIn: false, user: '', token: '', info: '', cfsf: '', planType: '', pinRegistartion: false };

export const loginUserAction = createAsyncThunk(
  "userSlice/login",
  async (params) => {
    try {
      const locationInfo = {
        ip: `${params.ipAddress}`,
        deviceId: "",
        deviceType: params.browserName || "Web",
        lattitude: `${params.lat}`,
        longitude: `${params.lng}`,
      };
      const rowData = {
        username: `${params.username}`,
        password: `${params.password}`,
        role: 0,
        customAttributes: locationInfo,
      };
      
      const response = await fetch(LoginAuth, {
        method: "POST",
        headers: header,
        body: await EncryptPreLogin(JSON.stringify(rowData)),
      });
      const res = await response.text();
      const data = await DecryptPreLogin(res);
      const encodedString = data;

      const UserData = JSON.parse(htmlDecode(encodedString));
      if (UserData && UserData.data && UserData.data.accessToken) {
        const Login = CryptoJS.AES.encrypt(
          JSON.stringify(UserData.data.user),
          key
        ).toString();
        const userToken = CryptoJS.AES.encrypt(
          JSON.stringify(UserData.data.accessToken),
          key
        ).toString();
        const location = CryptoJS.AES.encrypt(
          JSON.stringify(locationInfo),
          key
        ).toString();
        // sessionStorage.setItem('user', JSON.stringify(Login));
        setSessionData(`token${tabId2}`, JSON.stringify(userToken));
        setSessionData(`user${tabId}`, JSON.stringify(Login));
        setSessionData(`info`, JSON.stringify(location));
        return UserData;
      }
      // if (!UserData) {
      //   return UserData.data;
      // }
      return UserData;
    } catch (err) {
      return err;
    }
  }
);

export const logout = () => {
  removeSessionData("user");
  removeSessionData("token");
  sessionStorage.clear();
  sessionStorage.clear();
  tabId = sessionStorage.getItem("tabId");
  if (!tabId) {
    tabId = generateUniqueId(36, 2, 15);
    sessionStorage.setItem("tabId", tabId);
  }
  tabId2 = sessionStorage.getItem("tabId2");
  if (!tabId2) {
    tabId2 = generateUniqueId(36, 2, 25);
    sessionStorage.setItem("tabId2", tabId2);
  }
  window.location.assign("/login");
};

// for fetch state list
export const getState = createEncryptedAsyncThunk(
  'userSlice/getState',
  GetStateList,
  {
    method: 'POST',
    prepareBody: () => ({
      userid: 0
    }),
  }
);

// for fetch city list
export const getCity = createEncryptedAsyncThunk(
  'userSlice/GetCityList',
  GetCityList,
  {
    method: 'POST',
    prepareBody: (params) => ({
      stateId: `${params.stateID}`
    }),
  },
);

export const getAppCongfigKeyDetailsPreLoginAction = createEncryptedAsyncThunk(
  "userSlice/getAppCongfigKeyDetailsPreLoginAction",
  GetAppCongfigKeyDetailsPreLogin,
  {
    prepareBody: (params) => ({
      master_key: params.master_key || '',
      authPwd: process.env.REACT_APP_API_AUTH_PASSWORD || '',
    }),
  }
);

// for check user detail pre-login
export const checkUserDetailsPreLoginAction = createEncryptedAsyncThunk(
  'userSlice/checkUserDetailsPreLoginAction',
  CheckUserDetailsPreLogin,
  {
    method: 'POST',
    prepareBody: (params) => ({
      username: params.username,
      authPwd: process.env.REACT_APP_API_AUTH_PASSWORD
    }),
  },
);

// for verify otp pre-login
export const verifyPreUserOTPAction = createEncryptedAsyncThunk(
  'userSlice/verifyPreUserOTPAction',
  VerifyPreUserOTP,
  {
    method: 'POST',
    prepareBody: (params) => ({
      otp: params.otp,
      auth_mode: params.auth_mode,
      type: params.type || 'DEVICE_AUTHORIZATION',
      userName: params.userName,
      role: params.role,
      mode: {
        mode1: "SMS",
        mode2: "EMAIL",
      },
      receiverDetails: {
        mobileNo: params.mobileNo,
        emailId: params.emailId,
      }
    }),
  },
);

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    loginSuccess(state, action) {
      return { ...state, user: action.payload.user, token: action.payload.accessToken };
    },
    loginFailed(state, action) {
      return { ...state, loginResponse: { status: true, msg: action.payload } };
    },
    loginLocation(state, action) {
      return { ...state, info: action.payload };
    },
    loginCfsf(state, action) {
      return { ...state, CfSERTQAER: action.payload.csrfToken };
    },
    setLoginStatesFalse(state) {
      return { ...state, fetchError: false };
    },
    updateToken(state, action) {
      const encryptedToken = CryptoJS.AES.encrypt(
        JSON.stringify(action.payload.payload.data.token),
        key,
      ).toString();
      sessionStorage.setItem(`token${tabId2}`, JSON.stringify(encryptedToken));
      return { ...state, token: action.payload.payload.data.token };
    },
    authLogout: (state) => {
      state.isLoggedIn = false;
      state.status = null;
      state.user = null;
      state.token = "";
      sessionStorage.clear()
    },
    authClearAction: (state) => {
      state.user = null;
      state.token = null;
      state.items = null;
      state.isLoggedIn = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUserAction.pending, (state) => {
        state.status = "loading";
      })
      .addCase(loginUserAction.fulfilled, (state, action) => {
        let newStatus = null
        let isLoggedIn = false
        if (
          action.payload.data
          // !action.payload.data.customAttribute || (action.payload.data.customAttribute && !action.payload.data.customAttribute.twoFactorAuthenticate)
          ) {
          state.user = { ...state.user, ...action.payload.data.user };
          state.token = action.payload.data.accessToken;
          // state.items = action.payload.data;
          newStatus = 'success'
          isLoggedIn = true
        }
        state.status = newStatus;
        state.isLoggedIn = isLoggedIn;
      })
      .addCase(loginUserAction.rejected, (state, action) => {
        state.status = "failed";
        state.isLoggedIn = false;
        state.error = action.error.message;
      })
      .addCase(getAppCongfigKeyDetailsPreLoginAction.fulfilled, (state, action) => {
        if (!_.isEmpty(action.meta) && !_.isEmpty(action.meta.arg) && action.meta.arg.master_key === MLMPlanTypeKey) {
          if (action.payload && !_.isEmpty(action.payload.data)){
            if (_.trim(action.payload.data.master_key) === MLMPlanTypeKey) {
              state.planType = action.payload.data.value || ''
            }
          }
        }
        if (!_.isEmpty(action.meta) && !_.isEmpty(action.meta.arg) && action.meta.arg.master_key === PinRegistrationEnableKey) {
          if (action.payload && !_.isEmpty(action.payload.data)){
            if (_.trim(action.payload.data.master_key) === PinRegistrationEnableKey) {
              state.pinRegistartion = action.payload.data.status || false
            }
          }
        }
      })
  }
});
export const { loginSuccess, loginToken, loginLocation, loginCfsf, loginFailed, updateToken } =
  userSlice.actions;
export default userSlice.reducer;